import React, { useContext } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { menuLinks } from "../routing/menuLinks";
import { Link } from "react-router-dom";
import { AuthContext } from "../authentication/Auth";
import { managerMenuLinks } from "../routing/managerMenuLinks";
import {useTranslation} from "react-i18next";

const PrevLink = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none !important;
  color: #000 !important;
  font-weight: 500;
`;

const NextLink = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none !important;
  color: #000 !important;
  font-weight: 500;
`;

export default function BottomNavLinks() {
  let location = useLocation();
  const { currentUser } = useContext(AuthContext);

  const context = useContext(AuthContext);


  var prevLink = ''; var nextLink = '';
  var pageLinksArr = [];
  let path = location.pathname;
  const { t } = useTranslation();
  if (currentUser) {
    const isMan = context.currentUser.claims.isManager;
    if (isMan) {
      managerMenuLinks.forEach(menu => {
        if (menu.link !== "/helpdoc") {
          if (menu?.submenu) {
            menu.submenu.forEach(sub => {
              if (sub?.submenu) {
                pageLinksArr.push(sub?.submenu[0].link);
              }
              else {
                pageLinksArr.push(sub.link)
              }
            });
          }
          else {
            pageLinksArr.push(menu.link);
          }
        }
      });
    }
    else {
      menuLinks.forEach(menu => {
        if (menu.link !== "/helpdoc") {
          if (menu?.submenu) {
            menu.submenu.forEach(sub => {
              if (sub?.submenu) {
                pageLinksArr.push(sub?.submenu[0].link);
              }
              else {
                pageLinksArr.push(sub.link)
              }
            });
          }
          else {
            pageLinksArr.push(menu.link);
          }
        }
      });
    }
  }

  return (
    <>
      {
        pageLinksArr.forEach((pageLink, index) => {
          if (path === pageLink) {
            let prevIndex = index - 1;
            let nextIndex = index + 1;
            prevLink = pageLinksArr[prevIndex];
            nextLink = pageLinksArr[nextIndex];
          }
        })
      }
      <div className="mainDiv" style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '10px 20px',
        marginTop: '20px'
      }}>
        <div>
          <PrevLink

            className="forward"
            style={{
              display: prevLink ? 'flex' : 'none'
            }}
            to={prevLink}
          >
            <ArrowBackIcon style={{
              marginRight: '10px'
            }} />
            <p style={{ margin: '0' }}>{t('previous')}</p>
          </PrevLink>
        </div>

        <div>
          <NextLink
            className="next"
            style={{
              display: nextLink ? 'flex' : 'none'
            }}
            to={nextLink}
          >
            <p style={{ margin: '0' }}>{t('next')}</p>
            <ArrowForwardIcon style={{
              marginLeft: '10px'
            }} />
          </NextLink>
        </div>
      </div>
    </>


  );

}